module.exports = __webpack_public_path__ + "img/icon-header-mypage.2c3d3766.svg";